import { Component } from "@angular/core";
import { OAuthService } from "app/services/o-auth";

@Component({
  templateUrl: './my-insights.component.html'
})
export class MyInsightsComponent {
  public club: any;

  constructor(private oAuthService: OAuthService) {
    this.club = this.oAuthService.getClub();
  }
}
